var I = Object.defineProperty, $ = Object.defineProperties;
var k = Object.getOwnPropertyDescriptors;
var y = Object.getOwnPropertySymbols;
var C = Object.prototype.hasOwnProperty, G = Object.prototype.propertyIsEnumerable;
var p = (e, t, n) => t in e ? I(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, d = (e, t) => {
  for (var n in t || (t = {}))
    C.call(t, n) && p(e, n, t[n]);
  if (y)
    for (var n of y(t))
      G.call(t, n) && p(e, n, t[n]);
  return e;
}, U = (e, t) => $(e, k(t));
var u = (e, t, n) => p(e, typeof t != "symbol" ? t + "" : t, n);
var i = (e, t, n) => new Promise((r, s) => {
  var a = (h) => {
    try {
      o(n.next(h));
    } catch (l) {
      s(l);
    }
  }, c = (h) => {
    try {
      o(n.throw(h));
    } catch (l) {
      s(l);
    }
  }, o = (h) => h.done ? r(h.value) : Promise.resolve(h.value).then(a, c);
  o((n = n.apply(e, t)).next());
});
const v = (e) => e ? {
  Authorization: `Bearer ${e}`
} : void 0, A = (e) => {
  try {
    return JSON.parse(e);
  } catch (t) {
    return;
  }
}, L = (e) => typeof e == "object" && e !== null && "message" in e;
class f extends Error {
  constructor({ status: n, url: r, body: s }) {
    const a = A(s), c = L(a) ? a.message : `Url ${r.toString()}, Status code: ${n}, Body: ${s}`;
    super(c);
    u(this, "status");
    u(this, "body");
    u(this, "url");
    this.status = n, this.body = s, this.url = r, Object.setPrototypeOf(this, new.target.prototype);
  }
}
const S = (e) => typeof e.status == "number", w = (e, t) => i(void 0, null, function* () {
  const n = yield fetch(e.toString(), d({ mode: "cors" }, t));
  if (!n.ok)
    throw new f({ status: n.status, url: e, body: yield n.text() });
  return n;
}), g = (e, t) => i(void 0, null, function* () {
  return yield (yield w(e, d({}, t))).json();
}), E = (e, t) => i(void 0, null, function* () {
  return w(e, d({ method: "POST" }, t));
}), b = {
  lbConnect: (e) => e.channelGroupId ? `connect/?channelId=${e.channelId}&channelGroupId=${e.channelGroupId}` : `connect/?channelId=${e.channelId}`,
  thumbnails: (e, t) => t ? e.channelGroupId ? `thumbnail/?channelGroupId=${e.channelGroupId}&auth.token=${t}&auth.type=jwt` : e.channelId ? `thumbnail/?channelId=${e.channelId}&auth.token=${t}&auth.type=jwt` : "thumbnail" : "thumbnail"
};
class F {
  constructor(t) {
    u(this, "baseUrl");
    u(this, "tokenFactory");
    this.baseUrl = new URL("/api/v2/", t.publicEndpoint).toString(), this.tokenFactory = t.tokenFactory;
  }
  /**
   * Returns everything needed to setup the connection of Vindral instance.
   */
  connect(t) {
    return i(this, null, function* () {
      const { channelId: n, channelGroupId: r } = t, s = { channelId: n, channelGroupId: r }, a = new URL(b.lbConnect(t), this.baseUrl), c = this.getAuthToken(s), o = yield g(a, { headers: this.getHeaders(c) });
      return {
        channels: o.channels.map((l) => {
          const m = this.toChannel(l, s);
          return U(d({}, m), {
            renditions: l.renditions,
            overrides: l.overrides
          });
        }),
        edges: o.edges,
        logsUrl: o.logsUrl,
        statsUrl: o.statsUrl,
        telemetry: o.telemetry
      };
    });
  }
  /**
   * Fetches information regarding a single channel.
   *
   * @param channelId the channel to fetch
   * @returns a [[Channel]] containing information about the requested channel.
   */
  getChannel(t) {
    return i(this, null, function* () {
      const n = { channelId: t }, r = new URL(`channel/${t}`, this.baseUrl), s = this.getAuthToken(n), a = yield g(r, { headers: this.getHeaders(s) });
      return this.toChannel(a, n, s);
    });
  }
  /**
   * Fetches channels within a channel group
   *
   * Note: The returned list includes inactive channels - check isLive to filter out only active channels
   *
   * @param channelGroup the channel group to fetch channels from
   * @returns an array of [[Channel]] that belong to the channel group
   */
  getChannels(t) {
    return i(this, null, function* () {
      const n = { channelGroupId: t }, r = new URL(`channels/${t}`, this.baseUrl), s = this.getAuthToken(n), a = yield g(r, { headers: this.getHeaders(s) });
      return this.toChannels(a, n, s);
    });
  }
  getHeaders(t) {
    var r;
    return (r = v(t)) != null ? r : {};
  }
  getAuthToken(t) {
    return this.tokenFactory ? this.tokenFactory(t) : void 0;
  }
  toChannels(t, n, r) {
    return t.map((s) => this.toChannel(s, n, r));
  }
  toChannel(t, n, r) {
    const { baseUrl: s, sizes: a } = t.thumbnail, c = s || new URL(b.thumbnails(n, r), this.baseUrl), o = a.map((h) => new URL(
      `?channelId=${t.channelId}&width=${h.width}&height=${h.height}${j(
        n,
        r
      )}`,
      c
    ).toString());
    return {
      channelId: t.channelId,
      name: t.name,
      isLive: t.isLive,
      thumbnailUrls: o
    };
  }
}
const j = (e, t) => t ? e.channelGroupId ? `&channelGroupId=${e.channelGroupId}&auth.token=${t}&auth.type=jwt` : `&auth.token=${t}&auth.type=jwt` : "";
export {
  F as A,
  S as i,
  E as p,
  A as t
};
